export enum KpiType {
    PA,
    Compulsory,
    Additional
}